import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { getUniqueOnProp } from 'app/app.component';
import { SnackService } from 'app/core/services/snackbar/snack.service';

@Component({
  selector: 'app-upload-file-popup',
  templateUrl: './upload-file-popup.component.html',
  styles: [
    /* language=SCSS */
    `
      .popup {
        min-width: 30vw;//350px;
        min-height: 200px;
      }

      .upload-icon {
        font-size: 60px;
        width: 50px;
        height: 50px;
      }

      .hidden-input {
        display: none !important;
      }
    `
  ]
})
export class UploadFilePopupComponent {
  public files: File[];

  allowedTypes: string[] = [];
  allowedTypesDescription: string = '';
  multiple: boolean = true;
  title: string;

  constructor(
    public dialogRef: MatDialogRef<UploadFilePopupComponent>,
    private cdr: ChangeDetectorRef,
    private snack: SnackService,
    @Inject(MAT_DIALOG_DATA) public data: {allowedTypes: string[], allowedTypesDescription: string, multiple?: boolean, title?: string}
  ) { }

  ngOnInit(): void {
    this.allowedTypes = this.data?.allowedTypes ?? [];
    this.allowedTypesDescription = this.data?.allowedTypesDescription ?? '';
    this.multiple = this.data?.multiple ?? true;
    this.title = this.data?.title ?? null;
  }

  onFilesAdded(event: any) {
    if(!event.addedFiles) return;

    var files = getUniqueOnProp([...this.files ?? [], ...event.addedFiles], 'name'); //todo fix getUnique throughout site!!!

    //filter allowed files only
    if(this.allowedTypes.length && this.allowedTypesDescription && files.filter(x => !this.allowedTypes.includes(this.getFileExtension(x))).length > 0)
      this.snack.showMsg(`Some files were excluded from the upload - you can only upload ${this.allowedTypesDescription} files here.`);

    files = files.filter(x => !this.allowedTypes.length || this.allowedTypes.includes(this.getFileExtension(x)));

    this.files = files;
    this.cdr.detectChanges();
  }

  private getFileExtension(file: File) {
    return file.name.toLowerCase().split('.')?.pop() ?? '';
  }

  removeFile(fileName: string) {
    this.files = this.files?.filter(x => x.name != fileName);
    this.cdr.detectChanges();
  }

  getSelectedFilesText() {
    if (this.files) {
      return this.files.length > 1 ? `${this.files.length} files selected` : this.files[0].name;
    }
    return 'No file selected';
  }

  getFileList() {
    return this.files ?? [];
  }

  onUpload(): void {
    this.dialogRef.close(this.files);
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
